module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('b', [_vm._v("Counting Swallows")])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "chauthor"
  }, [_vm._v("MORGAN GRAYCE WILLOW")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Flight patterns")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("above this intersection")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("where two cities meet,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("announce that mosquitoes")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("have hatched this mid-May day.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("There might be three,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("or maybe a dozen swallows,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("crossing the window frame")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("though never all at once,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("and never simply left to right.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Instead their ellipses flatten,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("loop, elongate into infinity signs,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("a calligraphy of hunger")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("against pale blue.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5487a7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chapter02.vue
// module id = 84
// module chunks = 0